<template>
  <header
    class="header-expanded pt-6 pb-4 px-5 relative box-border w-full bg-transparent"
  >
    <div
      class="flex items-start"
      :class="[avatarUrl ? 'justify-between' : 'justify-end']"
    >
      <img
        v-if="avatarUrl"
        class="h-12 rounded-full"
        :src="avatarUrl"
        alt="Avatar"
      />
      <header-actions
        :show-popout-button="showPopoutButton"
        :show-end-conversation-button="false"
      />
    </div>
    <h2
      v-dompurify-html="introHeading"
      class="mt-4 text-2xl mb-1.5 font-medium"
      :class="$dm('text-slate-900', 'dark:text-slate-50')"
    />
    <div v-dompurify-html="IntroBody" class="intro-body-wrap" />
  </header>
</template>

<script>
import HeaderActions from './HeaderActions';
import darkModeMixin from 'widget/mixins/darkModeMixin.js';
import messageFormatterMixin from 'shared/mixins/messageFormatterMixin';

export default {
  name: 'ChatHeaderExpanded',
  components: {
    HeaderActions,
  },
  mixins: [darkModeMixin, messageFormatterMixin],
  props: {
    avatarUrl: {
      type: String,
      default: '',
    },
    introHeading: {
      type: String,
      default: '',
    },
    introBody: {
      type: String,
      default: '',
    },
    showPopoutButton: {
      type: Boolean,
      default: false,
    },
    widgetColor: {
      type: String,
      default: '',
    },
  },
  computed: {
    IntroBody() {
      let s = this.formatMessage(this.introBody, false, false);
      return s;
    }
  },
  mounted() {
    document.documentElement.style.setProperty('--widget-color', this.widgetColor);
  }
};
</script>

<style lang="scss">
.intro-body-wrap {
  hr {
    color: #cbd5e1;
    margin: 0.65rem 0;
  }
  p {
    min-height: 1rem;
  }
  a {
    color: var(--widget-color);
    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
